import axios from "./axios-config";

export const getAllNotifications = async (keyword, page) => {

    let { data } = await axios.get(`/super-admin/announcements?keywords=${keyword ?? ""}&page=${page}`)
    return (data);

}

export const getSingleNotification = async (id) => {

    let { data } = await axios.get(`/super-admin/announcements/` + id)
    return data;

}
export const deleteSingleNotification = async (id) => {
    let { data } = await axios.delete(`/super-admin/announcements/` + id)
    return data;
}

export const updateSingleNotifications = async (postData) => {

    let { data } = await axios.post(`/super-admin/announcements/${postData.id}?_method=put`, postData.data)
    return data;
}

export const storeSingleNotifications = async (storeData) => {

    let { data } = await axios.post(`/super-admin/announcements`, storeData)
    return data
}


// export const getNotificationNotifications = async (data) => {
//     let { data } =  await axios.post(`/super-admin/Notifications/all/blogs`, data)
//     return data;
// }

// export const getWorkshopNotifications = async (data) => {
//     try {
//         let response = await axios.post(`/super-admin/Notifications/all/announcements`, data)
//         return (response.data);
//     } catch (error) {
//         return (error);
//     }
// }

